export const normalizeEnsambleValue = (value: string | undefined): string => {
  const trimmedValue = value?.trim();
  return trimmedValue === ";" ? "" : value ?? "";
};

export const isNonEmptyEnsamble = (value: string | undefined): boolean => {
  const trimmedValue = normalizeEnsambleValue(value).trim();
  return !!trimmedValue && trimmedValue !== ";";
};
